export const userRoleTypes = [
  "admin",
  "admin_reader",
  "consultant_user",
  "org_utility_credentials_admin",
  "org_admin",
] as const

export type UserRoleType = (typeof userRoleTypes)[number]

/** Roles that may create/edit/delete admin utility credentials. */
export const credentialManagerRoles = [
  "admin",
  "org_admin",
  "org_utility_credentials_admin",
] as const satisfies readonly UserRoleType[]

export const isCredentialManagerRole = (
  role: UserRoleType | null | undefined
): boolean =>
  role != null &&
  (credentialManagerRoles as readonly UserRoleType[]).includes(role)

export interface UserRole {
  description: string
  id: UserRoleType
  name: string
}

export const userRoles: UserRole[] = [
  {
    description: "impersonateRole.role.admin.description",
    id: "admin",
    name: "impersonateRole.role.admin.name",
  },
  {
    description: "impersonateRole.role.adminReader.description",
    id: "admin_reader",
    name: "impersonateRole.role.adminReader.name",
  },
  {
    description: "impersonateRole.role.nzeroOSUser.description",
    id: "consultant_user",
    name: "impersonateRole.role.nzeroOSUser.name",
  },
  {
    description: "impersonateRole.role.orgUtilityCredentialsAdmin.description",
    id: "org_utility_credentials_admin",
    name: "impersonateRole.role.orgUtilityCredentialsAdmin.name",
  },
  {
    description: "impersonateRole.role.orgAdmin.description",
    id: "org_admin",
    name: "impersonateRole.role.orgAdmin.name",
  },
]

export const nonAdminUserRoles: UserRole[] = userRoles.filter(
  (role) => role.id !== "admin" && role.id !== "admin_reader"
)
